import { createSelector } from '@reduxjs/toolkit';
import { selectRegionalDistrictsModal } from './selectRegionalDistrictsModal';

export const selectRegionalDistrictsForSearch = createSelector(selectRegionalDistrictsModal, ({ districts }) =>
  districts.map(({ id, name }) => ({ title: name, value: id })),
);
